import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import track, { SELECTED_CHART_METRIC } from '@src/utils/sensor/track';
import { selectedMetricChart } from '@store/metricsChartContainer/actions';
import { INVERTED_METRIC_SWITCH_MAP, METRIC_SWITCH_MAP } from '@utils/metrics';
import { intervalSelector } from '@store/common/selectors';
import { selectedMetricSelector, metricSelector } from '@store/metricsChartContainer/selectors';
import { getSelectedChartId } from './utils';
import MetricCard from '../MetricCard';
import useSetAnnotationsExport from '../../annotations/hooks/useSetAnnotationsExport';
import useSetMetricSeriesExport from '../hooks/export/useSetMetricSeriesExport';
import useSetTimeSeriesExport from '../hooks/export/useSetTimeSeriesExport';

import { useAtomValue } from 'jotai';
import { diagnosticsModeAtom, dodAtom, unitAtom } from '../atoms';
// import { useSetAIAlertEventEport } from '../hooks/alerts/useSetAIAlertEventExport';
// import { useSetManualAlertEventEport } from '../hooks/alerts/useSetManualAlertEventExport';

function Charts({ activeTool }) {
  const dispatch = useDispatch();

  const interval = useSelector(intervalSelector);
  const selectedMetric = useSelector(selectedMetricSelector);
  const metrics = useSelector(metricSelector);
  const unit = useAtomValue(unitAtom);

  const dodEnabled = useAtomValue(dodAtom);
  const diagMode = useAtomValue(diagnosticsModeAtom);

  // export
  useSetTimeSeriesExport();
  useSetMetricSeriesExport();
  useSetAnnotationsExport({ interval });
  // useSetAIAlertEventEport();
  // useSetManualAlertEventEport();

  // popup action moved from existing component
  const onSelect = (metricName) => {
    const chartId = getSelectedChartId(metricName);
    if (chartId) {
      const newMetricName = get(METRIC_SWITCH_MAP, metricName, metricName);
      // chart interactions should not trigger a state change
      if (selectedMetric === newMetricName) {
        return;
      }
      dispatch(selectedMetricChart(newMetricName, chartId));
      track({ event: SELECTED_CHART_METRIC, data: { metric: metricName } });
    }
  };

  return (
    <SortableContext items={metrics} strategy={rectSortingStrategy}>
      {metrics.map((metric: any) => {
        const metricKey = unit === '%' ? get(INVERTED_METRIC_SWITCH_MAP, metric, metric) : metric;

        return (
          <MetricCard
            key={metric}
            metric={metric}
            chartMetric={metricKey} // toggle state metric
            isSelected={selectedMetric === metric}
            onSelect={onSelect}
            diagMode={diagMode}
            showTrend={dodEnabled}
            activeTool={activeTool}
          />
        );
      })}
    </SortableContext>
  );
}

export default Charts;
